"use client";
import React, { ReactNode } from "react";
import CarouselSection from "../ui/carousel-section";
import { ProductModel } from "@/types/product";
import ProductCard from "./product-card";

const ProductsCarousel = ({
  products,
  title,
  subTitle,
  icon,
}: {
  products: ProductModel[];
  title: string;
  subTitle?: string;
  icon?: ReactNode;
}) => {
  return (
    <CarouselSection
      title={title}
      subTitle={subTitle}
      icon={icon}
      items={products}
      renderItem={(product) => <ProductCard product={product} />}
    />
  );
};

export default ProductsCarousel;
